import React from "react";

export default function Shopping_Cart_Page() {
    return (
        <div>
            Shopping Cart Page
        </div>
    )
}